import { loadGoogleMaps } from './googleMapsLoader'
import { loadKakaoMaps } from './kakaoMapsLoader'
import { getMapLabelClass } from './MapLabelOverlay'

export function getMapProvider (locale) {
  return String(locale || '').toLowerCase().indexOf('ko') === 0 ? 'kakao' : 'google'
}

export function googleZoomToKakaoLevel (zoom) {
  const level = 20 - Number(zoom || 16)
  return Math.max(1, Math.min(14, level))
}

export function loadMapApi (provider) {
  return provider === 'kakao' ? loadKakaoMaps() : loadGoogleMaps()
}

export function createMapAdapter (provider, api, nativeMap) {
  if (provider === 'kakao') return createKakaoAdapter(api, nativeMap)
  return createGoogleAdapter(api, nativeMap)
}

function createKakaoAdapter (maps, nativeMap) {
  return {
    provider: 'kakao',
    maps,
    nativeMap,
    setCenter (lat, lng) {
      nativeMap.setCenter(new maps.LatLng(Number(lat), Number(lng)))
    },
    createBounds () {
      return new maps.LatLngBounds()
    },
    extendBounds (bounds, lat, lng) {
      bounds.extend(new maps.LatLng(Number(lat), Number(lng)))
    },
    fitBounds (bounds) {
      nativeMap.setBounds(bounds)
    },
    createMarker (options) {
      const marker = new maps.Marker({
        position: new maps.LatLng(Number(options.lat), Number(options.lng)),
        image: new maps.MarkerImage(options.iconUrl, new maps.Size(options.width, options.height)),
        map: nativeMap,
        clickable: options.clickable,
        data: options.data
      })
      if (options.onClick) maps.event.addListener(marker, 'click', options.onClick)
      return marker
    },
    createLabel (options) {
      const label = new maps.CustomOverlay({
        position: new maps.LatLng(Number(options.lat), Number(options.lng)),
        content: options.content
      })
      label.setMap(nativeMap)
      return label
    }
  }
}

function createGoogleAdapter (maps, nativeMap) {
  return {
    provider: 'google',
    maps,
    nativeMap,
    setCenter (lat, lng) {
      nativeMap.setCenter({ lat: Number(lat), lng: Number(lng) })
    },
    createBounds () {
      return new maps.LatLngBounds()
    },
    extendBounds (bounds, lat, lng) {
      bounds.extend(new maps.LatLng(Number(lat), Number(lng)))
    },
    fitBounds (bounds) {
      nativeMap.fitBounds(bounds)
    },
    createMarker (options) {
      const marker = new maps.Marker({
        position: new maps.LatLng(Number(options.lat), Number(options.lng)),
        icon: {
          url: options.iconUrl,
          scaledSize: new maps.Size(options.width, options.height)
        },
        map: nativeMap,
        clickable: options.clickable
      })
      if (options.onClick) marker.addListener('click', options.onClick)
      return marker
    },
    createLabel (options) {
      const MapLabel = getMapLabelClass(maps)
      return new MapLabel({
        position: new maps.LatLng(Number(options.lat), Number(options.lng)),
        content: options.content,
        map: nativeMap
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/mapProvider.js